import { render, staticRenderFns } from "./RetailFMCG.vue?vue&type=template&id=2a8a02a9&"
import script from "./RetailFMCG.vue?vue&type=script&lang=js&"
export * from "./RetailFMCG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports